<template>
  <v-app app>
    <v-main class="asupload-container">
      <v-app-bar dense dark>
        <v-btn icon @click="goBack">
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title>用户登录</v-toolbar-title>

        <v-spacer></v-spacer>

        <template v-slot:extension>
          <v-tabs @change="onTabChange" v-model="activeTab" centered slider-color="yellow">
            <v-tab v-for="(t, index) in tabTitles" :key="index">{{ t }}</v-tab>
          </v-tabs>
        </template>
      </v-app-bar>

      <v-container>
        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="0" :value="0">
            <v-form ref="formSms" v-model="smsValid">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field v-model="accountSms" :counter="11" label="手机号" required></v-text-field>
                </v-col>
                <v-col cols="9">
                  <v-text-field v-model="checkcode" label="验证码" required></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    :disabled="getSmsLastMill() > 0"
                    @click="sendSmsCheckcode"
                    block
                  >{{ smsBtnText }}</v-btn>
                </v-col>
                <v-col cols="12">
                  <v-btn @click="startSmsLogin" block color="primary">登录</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
          <v-tab-item :key="1" :value="1">
            <v-form ref="formPasswd" v-model="passwdValid">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-text-field v-model="accountPasswd" :counter="11" label="手机号" required></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="mpasswd" label="认证码" required></v-text-field>
                </v-col>
                <v-col cols="12" class="mb-2">
                  <span
                    @click="showMpasswdGetDialog = true"
                    class="blue--text text-overline text-decoration-underline"
                  >如何获取认证码</span>
                </v-col>

                <v-col cols="12">
                  <v-btn @click="startPasswdLogin" block color="primary">登录</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
      <v-snackbar v-model="showErr" :timeout="8000">
        {{ errMessage }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="showErr = false">关闭</v-btn>
        </template>
      </v-snackbar>
      <v-overlay :value="isLoading" class="text-center" opacity="0.8">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-dialog v-model="showMpasswdGetDialog" scrollable>
        <v-card>
          <v-card-title>如何获取认证码？</v-card-title>
          <v-divider></v-divider>
          <div class="pt-5 pr-5 pl-5 pb-5">
            <ol>
              <li>打开达芬奇小助手，点击左上角图标</li>
              <li>点击查看认证码</li>
              <li>
                <v-img contain :src="require('../assets/dbas/vdbpassword.jpg')" />
              </li>
            </ol>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showMpasswdGetDialog = false">取消</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script>
// 验证码最短发送时间间隔 S
const SmsInterval = 40
const Lkey = 'VdbLoginLastSmsSendTime'
import { vDbLogin, sendCheckcode } from '../util/api'
export default {
  name: 'VdbLogin',
  data() {
    let activeTab
    switch (this.$route.params.way) {
      case 'dpasswd': {
        activeTab = 1
        break
      }
      case 'sms':
      default: {
        activeTab = 0
        break
      }
    }
    let lastSmsSendTime = 0
    try {
      if (window.localStorage.getItem(Lkey)) {
        lastSmsSendTime = parseInt(window.localStorage.getItem(Lkey), 10)
      }
    } catch (e) {
      lastSmsSendTime = 0
    }

    return {
      showMpasswdGetDialog: false,
      tabTitles: ['短信登录', '认证码登录'],
      activeTab,
      lastSmsSendTime,
      showErr: false,
      errMessage: '',

      smsValid: false,

      accountSms: '',
      accountPasswd: '',
      mpasswd: '',
      checkcode: '',
      smsBtnText: '',
      isLoading: false,
      passwdValid: false
    }
  },
  mounted() {
    this.smsTimeLooper()
  },

  methods: {
    tabIndexToName(index) {
      switch (index) {
        case 1: {
          return 'dpasswd'
        }
        case 0:
        default: {
          return 'sms'
        }
      }
    },
    onTabChange() {
      this.$router.replace({
        path: `/vdb_login/${this.tabIndexToName(this.activeTab)}`,
        query: this.$route.query
      })
    },
    goBack() {
      if (window.history.length <= 1) {
        this.$router.replace('/')
      } else {
        this.$router.back()
      }
    },
    getSmsLastSecond() {
      const now = new Date().getTime()
      return SmsInterval - Math.ceil((now - this.lastSmsSendTime) / 1000)
    },
    getSmsLastMill() {
      const now = new Date().getTime()
      return SmsInterval - (now - this.lastSmsSendTime) / 1000
    },
    sendSmsCheckcode() {
      if (this.getSmsLastMill() > 0) {
        this.showErr = true
        this.errMessage = `两次发送时间间隔过短，请${this.getSmsLastSecond()}秒后重新试`
        return
      }
      if (!this.accountSms || !/^\d{11}$/.test(this.accountSms)) {
        this.showErr = true
        this.errMessage = `请输入正确的手机号`
        return
      }
      this.lastSmsSendTime = new Date().getTime()

      window.localStorage.setItem(Lkey, this.lastSmsSendTime)
      sendCheckcode(this.accountSms)
      this.smsTimeLooper()
    },
    calcSmsBtnText() {
      let text = ''
      const now = new Date().getTime()
      if (this.getSmsLastMill() > 0) {
        text = `${this.getSmsLastSecond()} 秒`
      } else {
        text = '发送'
      }
      this.smsBtnText = text
    },
    smsTimeLooper() {
      if (this.getSmsLastMill() > 0) {
        this.calcSmsBtnText()
        setTimeout(this.smsTimeLooper, this)
      } else {
        this.calcSmsBtnText()
      }
    },

    async startSmsLogin() {
      if (!this.accountSms || !this.checkcode) {
        return
      }
      this.isLoading = true
      try {
        const loginRes = await vDbLogin({
          account: this.accountSms,
          checkcode: this.checkcode
        })

        this.doneLogin({
          account: this.accountSms,
          vuid: loginRes.vuid,
          token: loginRes.token
        })
      } catch (e) {
        this.showErr = true
        this.errMessage = e.message
      } finally {
        this.isLoading = false
      }
    },
    doneLogin(param) {
      this.$store.dispatch('user/saveLoginInfo', param)
      const { ruri = '/' } = this.$route.query
      this.$router.replace({
        path: ruri
      })
    },
    async startPasswdLogin() {
      if (!this.accountPasswd || !this.mpasswd) {
        return
      }
      this.isLoading = true
      try {
        const loginRes = await vDbLogin({
          account: this.accountPasswd,
          mpasswd: this.mpasswd
        })
        this.doneLogin({
          account: this.accountPasswd,
          vuid: loginRes.vuid,
          token: loginRes.token
        })
      } catch (e) {
        this.showErr = true
        this.errMessage = e.message
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
